"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.startBenchmark = startBenchmark;
exports.stopBenchmark = stopBenchmark;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var marks = {};

function startBenchmark(name) {
  var mark = new Benchmark(name);
  mark.start();
  marks[name] = mark;
}

function stopBenchmark(name) {
  var mark = marks[name];

  if (mark) {
    mark.end();
    mark.report();
    marks[name] = null;
  }
}

var Benchmark = /*#__PURE__*/function () {
  function Benchmark(name) {
    _classCallCheck(this, Benchmark);

    this.name = name;
    this.startTime = null;
    this.endTime = null;
    this.duration = null;
    this.marks = {};
  }

  _createClass(Benchmark, [{
    key: "start",
    value: function start() {
      this.startTime = performance.now();
      console.log("Benchmark ".concat(this.name, " started"));
    }
  }, {
    key: "mark",
    value: function mark(name) {
      this.marks[name] = performance.now();
    }
  }, {
    key: "end",
    value: function end() {
      this.endTime = performance.now();
      this.duration = this.endTime - this.startTime;
    }
  }, {
    key: "get",
    value: function get(name) {
      return this.marks[name];
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getMarks",
    value: function getMarks() {
      return this.marks;
    }
  }, {
    key: "getStartTime",
    value: function getStartTime() {
      return this.startTime;
    }
  }, {
    key: "getEndTime",
    value: function getEndTime() {
      return this.endTime;
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.name;
    }
  }, {
    key: "report",
    value: function report() {
      console.log("Benchmark ".concat(this.name, " took ").concat(this.duration, "ms"));
    }
  }]);

  return Benchmark;
}();

exports.default = Benchmark;